<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :placeholder="placeholder"
      :id="inputId"
      :disabled="disabled"
      autocomplete="off"
      class="form-control"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <typeahead
      v-model="inputValue"
      :async-function="typeahead"
      :data="typeaheadData"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      :target="'#' + inputId"
      ref="addressRef"
      @input="selectTypeahead"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'ActualAddressInput',

  components: { Hint },

  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  props: {
    inputLabel: {
      default: 'Адрес фактического проживания'
    },

    inputName: {
      default: 'actual_address'
    },

    inputHint: {
      default: undefined
    },

    typeaheadItemKey: {
      type: String,
      default: 'value'
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-actual-address-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-actual-address`
      }

      return inputId
    },

    placeholder () {
      if (this.disabled) {
        return ''
      }

      return 'Введите адрес в свободной форме'
    }
  }
}
</script>
